














































































































































































































import Vue from 'vue'
import * as _ from 'lodash'
import dayjs from 'dayjs'
// import { ExtranetApi } from '@/api/extranet'
import RemoteConfig from './RemoteConfig.vue'
import { extranetType, extranetRecordColumns } from '../data'
import { getComPorts } from '@/api/extranetSocketService'
import {
  ExtranetServiceProxy,
  GenerateExtranetCodeDTO,
  DiagnosticRecordsPageDTO
} from '@/service-proxies/app-v2/extranet.service-proxies'
import moment from 'moment'
import {getLocalStorage} from "@/utils/storage";

const esp = new ExtranetServiceProxy()

export default Vue.extend({
  name: 'DeviceTab',
  components: { RemoteConfig },
  props: {
    device: {
      type: Object,
      default: null
    },
    virtualLinkMsgList: {
      type: Array,
      default: () => []
    },
    comPortsList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      tabIndex: '1',
      isShowDiagnsis: false, // 是否显示诊断信息
      isfoldCode: true, // 是否隐藏诊断码
      newCode: '',
      expiryTimeType: 'A', // 到期类型
      expiryTime: null, // 到期时间
      configList: [], // 配置
      configLoadingStatus: false,
      dataList: [], // 记录
      recordParam: {
        current: 1,
        size: 10
      },
      totalRecord: 0,
      extranetType,
      extranetRecordColumns,
      form: this.$form.createForm(this),
      confirmLoading: false,
      showEndExtranetModal: false,
      addExtranetRecordForm: {
        faultDesc: '',
        handleOpinion: '',
        diagnosticPerson: ''
      }
    }
  },
  watch: {
    device: {
      handler(device) {
        // console.log(222222,device)
        if (device.id) {
          // tab1状态重置
          this.tabIndex = '1'
          this.isfoldCode = true
          this.isShowDiagnsis = true;
          const code = this.device.extranetCode ? this.device.extranetCode : ''
          this.newCode = code ? code.substr(0, 2) + '***' + code.substr(-1, 1) : ''
          this.device.expireTime = !this.device.expiredDate
            ? this.$t('indefinite')
            : dayjs(this.device.expiredDate).format('YYYY-MM-DD HH:mm:ss')
          this.expiryTimeType = 'A'
          this.expiryTime = null
          this.queryExtranet() // 查询配置信息
          // tab3状态重置
          this.loadRecord() // 查询记录
        } else {
          this.configList = []
          this.dataList = []
          this.totalRecord = 0
          this.expiryTime = null
          this.newCode = ''
          this.isShowDiagnsis = false
        }
      },
      deep: true
    },
    isfoldCode: {
      handler(isfoldCode) {
        if (isfoldCode) {
          this.newCode = this.device.extranetCode
            ? this.device.extranetCode.substr(0, 2) + '***' + this.device.extranetCode.substr(-1, 1)
            : ''
        } else {
          this.newCode = this.device.extranetCode
        }
      },
      immediate: true
    },
    virtualLinkMsgList: {
      handler(virtualLinkMsgList) {
        this.configList.map((config) => {
          if (virtualLinkMsgList.length) {
            virtualLinkMsgList.map((item) => {
              if (config.virtualIp === item.ip && config.virtualPort === item.port) {
                config.status = item.status // 0:disconnect; 1:connected
              }
            })
          } else {
            config.status = false
          }
        })
      },
      deep: true
    },
    /*expiryTime(val) {
      console.log('过期时间1：', val)
      console.log('过期时间：', dayjs(Number(this.expiryTime)).format('YYYY-MM-DD HH:mm:ss'))
    },*/
    expiryTimeType(val) {
      if (val === 'B') {
        this.expiryTime = moment(new Date(), 'YYYY-MM-DD HH:mm:ss')
      }
    }
  },
  created() {
    document.addEventListener('copy', (e) => {
      this.eventListenerCopy(e)
    })
  },
  destroyed() {
    document.removeEventListener('copy', (e) => {
      const value = window.getSelection().toString()
      if(!value){
        return
      }
      e.clipboardData.setData('text/plain', value)
      e.preventDefault()
    })
  },
  methods: {
    // 显示隐藏诊断码
    toggleCode() {
      // 6位诊断码，隐藏3-5位：12***6
      this.isfoldCode = !this.isfoldCode
    },
    // 切换显隐诊断信息
    toggleDiangsisInfo() {
      this.isShowDiagnsis = !this.isShowDiagnsis
    },
    chooseTimeType(value) {
      if (value === 'B') {
        // 有期限，选择具体日期时间
        this.expiryTimeType = 'B'
      } else {
        // 无期限
        this.expiryTime = null
      }
    },
    disabledStartDate(expiryTime) {
      if (!expiryTime) {
        return false
      }
      return expiryTime.valueOf() < new Date().valueOf()
    },
    // 生成指定设备的远程诊断码
    createExtranetCode() {
      if (!this.device.id) {
        return
      }
      let id: string = this.device.id
      let expireTime
      if (this.expiryTimeType === 'A') {
        expireTime = null
      } else {
        if (this.expiryTime) {
          expireTime = dayjs(Number(this.expiryTime)).format('YYYY-MM-DD HH:mm:ss')
        } else {
          expireTime = dayjs(Number(new Date())).format('YYYY-MM-DD HH:mm:ss')
        }
      }
      const params = {
        workStationId: id,
        expireTime
      }

      esp.generateExtranetCode(new GenerateExtranetCodeDTO(params)).then((res) => {
        if (res) {
          const user = getLocalStorage('USER_INFO');
          console.log('user', user);
          this.$emit('changeCode', { code: res.code, simpleToken: '' })
          this.$emit('getDeviceInfo', 'showCode')
          this.$emit('beginServer')
          this.loadRecord()
        }
      })
    },
    // 停止诊断
    stopDiagnose(id) {
      esp.stopExtranet(id).then((res) => {
        this.$emit('getDeviceInfo') // 手动更新当前设备详情
        this.$emit('endDiagnosis')
        this.loadRecord()
      })
    },
    eventListenerCopy(e) {
      const value = window.getSelection().toString()
      if(!value) {
        if(!this.device.extranetCode){
          return
        }
        e.clipboardData.setData('text/plain', this.device.extranetCode)
        e.preventDefault()
        return
      } else {
        e.clipboardData.setData('text/plain', value)
        e.preventDefault()
      }
    },
    // 拷贝诊断码
    copy() {
      document.execCommand('Copy') // 执行浏览器复制命令
      this.$message.success(this.$t('page_my_document_copysuccess') + '！')
    },
    loadRecord(pagination) {
      this.recordParam.current = pagination ? pagination.current : 1
      this.getRecordList()
    },
    // 查询诊断记录
    getRecordList() {
      const params: any = { deviceId: this.device.id, pageRequestDTO: { ...this.recordParam } }

      esp.getExtranetRecord(params).then((res) => {
        if (!res.list) {
          return
        }
        this.dataList = res.list
        this.totalRecord = res.totalCount
        this.dataList.map((item, index) => {
          item.key = index
          item.operationTime = dayjs(item.operationTime).format('YYYY-MM-DD HH:mm:ss')
          item.diagnosticType = this.extranetType[item.diagnosticType]
        })
      })
    },
    // 查询设备配置信息
    queryExtranet() {
      if (!this.device.id) {
        return
      }
      this.configLoadingStatus = true
      esp
        .queryDeviceExtranetConfigOutList(this.device.id)
        .then((res) => {
          if (res && res.length) {
            this.configList = res
            this.configLoadingStatus = false
            this.configList.map((config) => {
              if (this.virtualLinkMsgList.length) {
                this.virtualLinkMsgList.map((item) => {
                  if (config.virtualIp === item.ip && config.virtualPort === item.port) {
                    config.status = item.status // 0:disconnect; 1:connected
                  }
                })
              } else {
                config.status = false
              }

              if (config.protocol.toLowerCase() === 'serial') {
                config.virtualIp = 'COM' + config.virtualIp.replace(/[^0-9]/gi, '')
                config.ip = 'COM' + config.ip.replace(/[^0-9]/gi, '')
                config.virtualPort = ''
                config.port = ''
              }
            })
          } else {
            this.configList = []
          }
        })
        .finally(() => {
          this.configLoadingStatus = false
        })
    },
    // 配置信息的增删改操作处理
    handleConfigAction(data) {
      if (data.type) {
        if (data.type === 'add') {
          this.addExtranet(data.data)
        } else {
          this.updateExtranet(data.data)
        }
      } else {
        // 删除
        this.deleteExtranet(data)
      }
    },
    // 添加配置信息
    async addExtranet(data) {
      // let params = {
      //   "workStationId": "string",
      //   "virtualIp": "string",
      //   "virtualPort": 0,
      //   "ip": "string",
      //   "port": 0,
      //   "protocol": "string",
      //   "appProtocol": "string"
      // };
      await esp.addDeviceExtranetConfig(data)
      this.queryExtranet()
    },
    // 修改配置信息
    async updateExtranet(data) {
      const params = _.cloneDeep(data)
      delete params.id
      await esp.updateDeviceExtranetConfig(data.id, params)
      this.queryExtranet()
    },
    // 删除配置信息
    async deleteExtranet(id) {
      await esp.delDeviceExtranetConfig(id)
      this.queryExtranet()
    },
    // 确认断开链路
    handleOk() {
      this.confirmLoading = true
      const param = Object.assign({}, this.addExtranetRecordForm, { workStationId: this.device.id })
      esp.addExtranetRecord(param).then((res) => {
        this.addExtranetRecordForm = {
          faultDesc: '',
          handleOpinion: '',
          diagnosticPerson: ''
        }
        this.confirmLoading = false
        this.showEndExtranetModal = false
        this.stopDiagnose(this.device.id)
      })
    },
    handleCancel() {
      this.showEndExtranetModal = false
    }
  }
})
